module.exports=[
  {
    "specifics": "Tears, Smiles Mingle as Japs Bid Bainbridge Farewell",
    "svg": "IL-1",
    "final_category": "Inaccurate language",
    "caption_popup": "This language downplays the forced nature and extraorindary situation of the exclusion order. Today, we would use language that makes it clear that Japanese American Bainbridge residents were being forced to leave their homes due to a racist federal policy."
  },
  {
    "specifics": "Bainbridge island Japanese, alien and 'American-born alike,",
    "svg": "IL-2",
    "final_category": "Inaccurate language",
    "caption_popup": "The use of the term \"Japanese\" throughout this story is not accurate and emphasizes \"foreignness.\" We would also avoid the term \"alien,\" which is offensive and inaccurate. We would accurately describe them as Japanese Americans and Bainbridge Island residents."
  },
  {
    "specifics": "having left voluntarily.",
    "svg": "IL-3",
    "final_category": "Inaccurate language",
    "caption_popup": "We wouldn't use the word \"voluntarily.\" It is inaccurate to say that anyone forced to leave their home by a federal order is leaving \"voluntarily.\""
  },
  {
    "specifics": "The soliders courteously escorted the Japanese aboard the ferry.",
    "svg": "IL-4",
    "final_category": "Inaccurate language",
    "caption_popup": "This language misrepresents the reality of the situation. We would accurately represent the soldiers' role as armed guards there to enact the executive order forcing of U.S. residents and citizens from their homes."
  },
  {
    "specifics": "The Japanese by this time were smiling but there were many solider, including even officers, who had tears streaming down their",
    "svg": "IL-5",
    "final_category": "Inaccurate language",
    "caption_popup": "At best, this is a confusing characterization that would raise flags today. At worst it is a racist depiction that dehumanizes and stereotypes the Japanese Americans who are being forced to leave their homes as naive while depicting the soldiers as emotionally complex. We would question this description's accuracy and require a rewrite as well as explanation or quotes from the soldiers and the people being forced to leave, so they could speak about their feelings themselves."
  },
  {
    "specifics": "The Japanese had left their homes, in which some had lived for as many as 40 years.",
    "svg": "IL-7",
    "final_category": "Inaccurate language",
    "caption_popup": "We would not refer to people with this label, which is inaccurate. We would write that \"Japanese Americans\" or \"people of Japanese heritage\" were singled out by Order 9066."
  },
  {
    "specifics": "Ebaristo Arota a Filipino, remained on the island while his Japanese wife, Miki, sadly boarded the ferry.",
    "svg": "IL-8",
    "final_category": "Inaccurate language",
    "caption_popup": "We would not refer to the couple as \"a Filipino\" and \"Japanese wife,\" which is inaccurate and implies they are not U.S. citizens or residents. We would also move their story up much higher in the story to illustrate how narrowly the order targeted people."
  },
  {
    "specifics": "Soliders guarded the ferry dock at Eagle Harbor as the island Japanese were evacuated.",
    "svg": "IL-9",
    "final_category": "Inaccurate language",
    "caption_popup": "We would not refer to the Bainbridge Island residents as \"island Japanese,\" which is inaccurate and implies that these residents are \"different,\" while the men with rifles are \"normal.\""
  },
  {
    "specifics": "One elderly woman was stricken with a heart attack as she awaited the ferry at Eagledale which was to take her to new surroundings in California.",
    "svg": "IM-2",
    "final_category": "Inaccuracy/misrepresentation",
    "caption_popup": "The phrase \"new surroundings\" is too vague, inaccurately describing the facility these residents were sent to. We'd call it what it was: a concentration camp."
  },
  {
    "specifics": "It was accomplished in orderly fashion.",
    "svg": "IM-3",
    "final_category": "Inaccuracy/misrepresentation",
    "caption_popup": "We would not use the term \"orderly fashion,\" which is a term often used to describe school lines or routine drills. It downplays the significance of this event and centers \"orderliness\" as the importance aspect of the forced removal and incarceration. We would ask the reporter to speak with more sources to center the stories and feelings of those being forced to leave."
  },
  {
    "specifics": "There were one or more soliders for each family.",
    "svg": "IM-4",
    "final_category": "Inaccuracy/misrepresentation",
    "caption_popup": "The sentence \"there were one or more soldiers for each family\" is vague and inaccurate. We would edit this to more accurately explain the role of the soldiers on Bainbridge Island, which was to enforce compliance with the executive order. We would also ask the reporter for more information about how the soldiers treated the residents being forced to leave."
  },
  {
    "specifics": "Sad Farewells - While Troops Stand By",
    "svg": "IM-6",
    "final_category": "Inaccuracy/misrepresentation",
    "caption_popup": "Again, we would not refer to the events of this day as \"farewells,\" which softened the forced, discriminatory nature of the policy."
  },
  {
    "specifics": "The scene was typical as evacuation proceeded under Army supervison.",
    "svg": "IM-7",
    "final_category": "Inaccuracy/misrepresentation",
    "caption_popup": "This caption is innacurate, so we wouldn't use it. It was not an \"evacuation under supervision,\" it was a forced eviction with an armed guard. We would also try to quote the woman in the photo about having to leave her home under armed guard."
  },
  {
    "specifics": "Once aboard, the evacuees were given the run of the boat except for the lower deck.",
    "svg": "LI-1",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "This detail is too vague and not related to what should be the focus of the story — the experiences of those being forcibly removed. Today, we would ask that the reporter add more detail to indicate why this detail is important to the story or cut it."
  },
  {
    "specifics": "\"I don't know, but we will be back.\"",
    "svg": "LI-3",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "This story is lacking crucial information, such as whether the federal order had an end date when families could return, and whether the military communicated with families about where they were going."
  },
  {
    "specifics": "These friends, as well as soliders gave the departing Japanese every help.",
    "svg": "LI-4",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "This line is too vague and generalizing. We would ask the reporter to specify what \"every help\" means and give specific examples. Today, we know that this was at best only partially accurate, as we know that many people took the removal as an opportunity to profit by stealing their incarcerated neighbors' property. We would require the reporter to balance the story by looking for examples of that."
  },
  {
    "specifics": "Army officials said they were compelled to deny a request that either Arota be taken with the evacuees or Mrs. Arota be allowed to stay.",
    "svg": "LI-5",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "This statement is too vague. Today, we would require the reporter to find out where this command originated and if it was part of the executive order to separate families of different ethnicities or nationalities."
  },
  {
    "specifics": "Yesterday was a busy one for the island's \"orphans of war,\" as they have designated themselves.",
    "svg": "LI-6",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "We would include more detail about this designation \"orphans of war\" by quoting people who used this term for themselves or explaining what it meant, who used it and why."
  },
  {
    "specifics": "The island Japanese had set their affairs in order in eight short days, under Army orders.",
    "svg": "LI-7",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "We would include more detail about why they had only eight days and what they had to do to be \"ready.\" We likely would have run a story in a previous issue about how residents made decisions about what to bring, and what and who they left behind."
  },
  {
    "specifics": "A scene reminiscent of a Midwest farm auction was enacted yesterday at the Kitayama Greenhouse and Gardens at Pleasant Beach.",
    "svg": "LI-8",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "Accounts from those incarcerated indicate that these descriptions of events are inaccurate and fail to mention the large financial losses to those whose belongings were sold at bargain prices, stolen, or destroyed and the fact that Japanese Americans were reclassified as 4C \"enemy aliens\" and barred from military service. The Seattle Times collaborated with Densho to provide historical context for this annotation."
  },
  {
    "specifics": "Japanese are regretful but not biter about their departure.",
    "svg": "LI-9",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "The phrase \"regretful but not bitter\" is overgeneralized, and reinforces the \"model minority\" myth about Asian Americans. We would ask the reporter to find more sources that show the diversity of feelings and perspectives about the forced evacuation."
  },
  {
    "specifics": "A strange collection of materials began gathering in the storehouse opened at the Winslow by the Federal Reserve Bank of San Francisco, custodian for the enemy-alien property.",
    "svg": "OL-2",
    "final_category": "Offensive language",
    "caption_popup": "We would not refer to people's personal belongings as \"strange,\" because it marginalizes U.S. residents of Japanese heritage by implying that they and their property do not belong."
  },
  {
    "specifics": "A strange collection of materials began gathering in the storehouse opened at the Winslow by the Federal Reserve Bank of San Francisco, custodian for the enemy-alien property.",
    "svg": "OL-3",
    "final_category": "Offensive language",
    "caption_popup": "We wouldn't use the criminalizing term \"enemy-alien\" because it makes the reader associate these residents with the term \"enemy\" even more. We do not use the term \"alien\" to refer to people, because it is an offensive and dehumanizing term that implies a person does not belong in the U.S."
  },
  {
    "specifics": "",
    "svg": "PS-2",
    "final_category": "Photo selection",
    "caption_popup": "We would not use these photos today because they appear staged and misleading. We emphasize true, documentary moments. When we ask people to pose for portraits, we ensure that the image is clearly a portrait and work with the person on how they are depicted, including whether they want to smile. These images fail to meet those standards. If we would have used a photo of soldiers, we would have reduced the size in order to place more emphasis on the people who are most impacted. "
  },
  {
    "specifics": "",
    "svg": "PS-3",
    "final_category": "Photo selection",
    "caption_popup": "We would not use this photo, because it looks very staged. Our photographers would try to capture photos of the events as they were actually happening."
  },
  {
    "specifics": "Ebaristo Arota a Filipino, remained on the island while his Japanese wife, Miki, sadly boarded the ferry.",
    "svg": "PS-4",
    "final_category": "Photo selection",
    "caption_popup": "We would avoid using this photo because it appears to be posed instead of an authentic moment. This photo is also missing a caption to provide additional context and identify the people in the image. We would not publish this image without a caption."
  },
  {
    "specifics": "",
    "svg": "RL-2",
    "final_category": "Racist language",
    "caption_popup": "We would not use a racist stereotype to describe people."
  },
  {
    "specifics": "Tears, Smiles Mingle as Japs Bid Bainbridge Farewell",
    "svg": "RL-4",
    "final_category": "Racist language",
    "caption_popup": "Just as we wouldn't run this headline on A1, we also wouldn't run it on the jump; it's racist and inaccurate."
  },
  {
    "specifics": "",
    "svg": "SF-1",
    "final_category": "Story framing/focus (bias)",
    "caption_popup": "\"Credit to the efficiency of the army\" is commentary from the reporter that may indicate the reporter's bias and/or susceptibility to propaganda. We would cut this line and ask the reporter to show how the day's events transpired by letting the sources speak for themselves and describing their actions."
  },
  {
    "specifics": "",
    "svg": "SF-2",
    "final_category": "Story framing/focus (bias)",
    "caption_popup": "Phrases like \"marred an orderly evacuation\" and \"only one incident\" falsely center orderliness as the important aspect of this anecdote. They also belittle and dehumanize the woman who had a heart attack, and imply that the forced removal was \"right.\" We would cut these phrases and ask the reporter to find out who the woman was, talk to her family and learn more about her condition and treatment."
  },
  {
    "specifics": "The minister expressed pride over the way members of his race accepted evaucation.",
    "svg": "SF-3",
    "final_category": "Story framing/focus (bias)",
    "caption_popup": "The phrase \"pride over the way members of his race accepted evacuation\" frames accepting relocation as something done by loyal Japanese Americans vs. (presumably) disloyal ones."
  },
  {
    "specifics": "They knew she couldn't however, and it appeared that one company might have a new mascot - a kitten.",
    "svg": "SF-4",
    "final_category": "Story framing/focus (bias)",
    "caption_popup": "We would likely cut this anecdote. The upbeat tone of the anecdote, particularly about the \"new mascot,\" contrasts offensively against the seriousness of the situation."
  },
  {
    "specifics": "The Army made no arrangements for pets. This was a hard blow to many children who had to part with dogs and cats.",
    "svg": "SF-5",
    "final_category": "Story framing/focus (bias)",
    "caption_popup": "This passage conveys more sympathy for the loss of pets than for the displacement of people."
  },
  {
    "specifics": "He told about Harry Hiroshita, who was known in the early part of the century as \"Slabwood Harry.\"",
    "svg": "SE-1",
    "final_category": "Sourcing errors",
    "caption_popup": "Today we would center and seek quotes from those who were the most impacted — the residents who were being forcibly removed."
  },
  {
    "specifics": "\"What has to be, has to be,\" said Mr. Hirakawa, smiling.",
    "svg": "SE-2",
    "final_category": "Sourcing errors",
    "caption_popup": "Of the three Japanese American residents quoted in this story all of them (except the little girl who can't bring her kitten) are quoted as being eager to help the war effort by leaving or accepting the situation. We would recognize this today as an unbalanced perspective and one that may be influenced by fear of retaliation or of appearing to be against the U.S. government at a time of high anti-Japanese sentiment. Given this difficulty, we would offer anonymity to those sources, seek out sources with different perspectives and consider ways to protect sources willing to share perspectives that could endanger them. We would also plan follow-up stories that investigated the conditions at the incarceration camps."
  }
]